// 1. jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// 2. Bootstrap CSS e JS (deve ser carregado antes dos plugins)
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap; // cria global para bootstrap-select

// 3. Bootstrap Select (depende do Bootstrap)
import 'bootstrap-select';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';

// 4. Select2 (depende do jQuery)
import select2 from 'select2';
import 'select2/dist/css/select2.min.css';

// Registrar Select2 no jQuery
select2($);

// 5. Alpine - Usando Alpine do Livewire 3 (não importar separadamente)
// Os componentes são registrados no evento alpine:init
// Temperature Slider Component

document.addEventListener('alpine:init', () => {
    Alpine.data('tempSlider', (minVal = -10, maxVal = 25) => ({
        minValue: minVal,
        maxValue: maxVal,
        minLimit: -15,
        maxLimit: 40,
        minGap: 1,

        init() {
            this.updateValues();
        },

        get minPercent() {
            return ((this.minValue - this.minLimit) / (this.maxLimit - this.minLimit)) * 100;
        },

        get maxPercent() {
            return ((this.maxValue - this.minLimit) / (this.maxLimit - this.minLimit)) * 100;
        },

        updateValues() {
            // Prevent crossing and maintain minimum gap
            if (this.maxValue - this.minValue < this.minGap) {
                if (this.minValue > this.maxValue - this.minGap) {
                    this.minValue = this.maxValue - this.minGap;
                } else {
                    this.maxValue = this.minValue + this.minGap;
                }
            }

            // Ensure values stay within limits
            this.minValue = Math.max(this.minLimit, Math.min(this.maxLimit, this.minValue));
            this.maxValue = Math.max(this.minLimit, Math.min(this.maxLimit, this.maxValue));
        }
    }));
});

// 4. FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css';

// 5. CSS do app
import '../css/app.css';


// import Swiper JS
import Swiper from 'swiper';
import {Navigation, Pagination, Scrollbar} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
window.Swiper = Swiper;


/* ***************************** Custom js ***************************** */
/* Pagina plantas (u,c) */
$(document).ready(function () {
    $('#botao-expansivel').on('click', function () {
        $('#conteudo-expansivel').slideToggle();
    });

    $('.menu-option').on('click', function () {
        const mode = $(this).data('mode');
        const type = $(this).data('type');

        $('.cultivo-row, .colheita-row').hide();

        if (mode === 'only-cultivo') {
            $(`.cultivo-${type}`).show();
        } else if (mode === 'only-colheita') {
            $('.colheita-row').show();
        } else if (mode === 'all') {
            $('.cultivo-terra, .cultivo-viveiro, .cultivo-transplante, .colheita-row').show();
        }
    });

    $('.plant-type-header').on('click', function () {
        const targetSelector = $(this).data('target');
        $(targetSelector).slideToggle();
    });

    $(document).ready(function () {
        // Define limites do slider (podes ajustar aqui)
        const MIN_LIMIT = -15;
        const MAX_LIMIT = 40;
        const MIN_GAP = 1; // diferença mínima entre os thumbs (graus)

        // inicializa atributos dos inputs
        const $min = $('#min-range').attr({min: MIN_LIMIT, max: MAX_LIMIT});
        const $max = $('#max-range').attr({min: MIN_LIMIT, max: MAX_LIMIT});
        const $range = $('#active-range');
        const $minVal = $('#min-val');
        const $maxVal = $('#max-val');

        // Função que converte valor para percentagem normalizada (0..100)
        // tendo em conta limites negativos:
        function valueToPercent(val) {
            const min = Number($min.attr('min'));
            const max = Number($min.attr('max')); // ambos têm same range
            return ((Number(val) - min) / (max - min)) * 100;
        }

        function update(e) {
            // valores actuais
            let minV = parseInt($min.val(), 10);
            let maxV = parseInt($max.val(), 10);

            // impede cruzamento: garante gap mínimo
            if (maxV - minV < MIN_GAP) {
                if (e && $(e.target).is($min)) {
                    minV = maxV - MIN_GAP;
                    $min.val(minV);
                } else {
                    maxV = minV + MIN_GAP;
                    $max.val(maxV);
                }
            }

            // actualiza texto com ºC
            $minVal.text(minV + '°C');
            $maxVal.text(maxV + '°C');

            // converte para percentagens (0..100) com base em MIN_LIMIT..MAX_LIMIT
            const pMin = valueToPercent(minV);
            const pMax = valueToPercent(maxV);

            // actualiza a faixa activa (left e width)
            $range.css({
                left: pMin + '%',
                width: (pMax - pMin) + '%'
            });
        }

        // liga eventos (input para resposta em tempo real)
        $min.on('input', update);
        $max.on('input', update);

        // valores iniciais (podes alterar os valores iniciais nos atributos value)
        // garante que os atributos min/max dos inputs estão definidos no DOM (para valueToPercent)
        $min.attr({min: MIN_LIMIT, max: MAX_LIMIT});
        $max.attr({min: MIN_LIMIT, max: MAX_LIMIT});

        // se quiseres, define valores iniciais aqui:
        if (!$min.val()) $min.val(-10);
        if (!$max.val()) $max.val(25);

        // desenha pela 1ª vez
        update();
    });
});
/**
 * Atualiza a preview de uma imagem ao selecionar um novo arquivo.
 *
 * @param {Event} event - O evento de seleção de arquivo.
 */
$(document).ready(function () {
    $('.file-input').on('change', function (event) {
        const input = event.target;
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                $('.preview-image').attr('src', e.target.result);
            }
            reader.readAsDataURL(input.files[0]);
        }
    });

    // Initialize bootstrap-select for country dropdown
    if ($.fn.selectpicker) {
        $.fn.selectpicker.Constructor.BootstrapVersion = '5';
        $('.selectpicker').selectpicker({
            width: 'fit',
            showTick: true,
            size: false
        });
    }

    // Initialize Select2
    $('.select2').select2({
        width: '100%',
        theme: 'bootstrap-5',
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }
            const countryCode = $(data.element).data('code');
            if (countryCode) {
                const flagEmoji = countryCode
                    .toUpperCase()
                    .split('')
                    .map(char => String.fromCodePoint(0x1F1E6 + char.charCodeAt(0) - 65))
                    .join('');
                return $(
                    '<span>' + flagEmoji + ' ' + data.text + '</span>'
                );
            }
            return data.text;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }
            const countryCode = $(data.element).data('code');
            if (countryCode) {
                const flagEmoji = countryCode
                    .toUpperCase()
                    .split('')
                    .map(char => String.fromCodePoint(0x1F1E6 + char.charCodeAt(0) - 65))
                    .join('');
                return $(
                    '<span>' + flagEmoji + ' ' + data.text + '</span>'
                );
            }
            return data.text;
        }
    });
});
$(document).ready(function () {
})

// Registra os módulos que irá usar
Swiper.use([Navigation, Pagination, Scrollbar]);

document.addEventListener('livewire:init', () => {

    Livewire.on('initSwiperSecundarias', () => {
        const swiperContainer = document.getElementById('mySwiper');

        if (!swiperContainer) return;

        // Delay para garantir que os slides foram renderizados
        setTimeout(() => {
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            const slidesCount = slides.length;

            if (slidesCount === 0) return; // Proteção extra

            // Destroi instância anterior se existir
            if (swiperContainer.swiper) {
                swiperContainer.swiper.destroy(true, true);
            }

            const shouldLoop = slidesCount >= 3;

            const mySwiper = new Swiper(swiperContainer, {
                direction: 'horizontal',
                slidesPerView: 2,
                loop: shouldLoop,
                slideToClickedSlide: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: true,
                },
                spaceBetween: 0,
            });

            swiperContainer.swiper = mySwiper;

            mySwiper.on('slideChange', () => {
                const realIndex = mySwiper.realIndex;
                const activeSlide = slides[realIndex];
                const previewImage = document.querySelector('img.preview-image');

                if (activeSlide && previewImage) {
                    const imgInSlide = activeSlide.querySelector('img');
                    if (imgInSlide && imgInSlide.src) {
                        previewImage.src = imgInSlide.src;
                    }
                }
            });
        }, 50); // 50ms é geralmente suficiente para Livewire renderizar
    });
});



